import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from "@mui/material";
import { FormProvider } from "react-hook-form";
const StyledForm = styled('form')({
    display: 'contents'
});
export const Form = ({ methods, ...props })=>/*#__PURE__*/ _jsx(FormProvider, {
        ...methods,
        children: /*#__PURE__*/ _jsx(StyledForm, {
            ...props
        })
    });
Form.displayName = 'Form';

//# sourceMappingURL=Form.js.map